import { SITE } from "@/constants/site";

const WA_URL = `https://wa.me/919063428151?text=${encodeURIComponent(
  "Hello Adipurusa Infotech, I would like to know more about your programs and services."
)}`;

export const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Chat with us on WhatsApp at ${SITE.phone}`}
    data-testid="whatsapp-chat-button"
    className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/30 hover:bg-[#1fb857] hover:scale-105 transition-transform duration-200"
  >
    <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
      <path d="M16.04 2.67c-7.33 0-13.3 5.96-13.3 13.29 0 2.34.62 4.63 1.79 6.64L2.67 29.33l6.9-1.81a13.24 13.24 0 0 0 6.46 1.65h.01c7.33 0 13.29-5.97 13.29-13.3 0-3.55-1.38-6.89-3.9-9.4a13.2 13.2 0 0 0-9.39-3.9zm0 24.26h-.01c-2.02 0-4-.54-5.72-1.57l-.41-.24-4.09 1.07 1.09-3.99-.27-.41a11.02 11.02 0 0 1-1.69-5.84c0-6.1 4.97-11.07 11.08-11.07 2.96 0 5.74 1.15 7.83 3.25a11 11 0 0 1 3.24 7.83c0 6.1-4.97 11.07-11.05 11.07zm6.07-8.29c-.33-.17-1.97-.97-2.27-1.08-.31-.11-.53-.17-.75.16-.22.33-.86 1.08-1.05 1.31-.19.22-.39.25-.72.08-.33-.16-1.4-.51-2.66-1.64-.98-.88-1.65-1.96-1.84-2.29-.19-.33-.02-.51.15-.68.15-.15.33-.39.5-.58.16-.2.22-.33.33-.55.11-.22.06-.42-.03-.58-.08-.17-.75-1.8-1.02-2.47-.27-.65-.55-.56-.75-.57h-.64c-.22 0-.58.08-.88.42-.31.33-1.16 1.13-1.16 2.76s1.19 3.2 1.35 3.42c.17.22 2.33 3.56 5.65 4.99.79.34 1.41.54 1.89.7.79.25 1.52.21 2.09.13.64-.1 1.97-.81 2.24-1.59.28-.78.28-1.44.2-1.58-.08-.14-.3-.22-.63-.39z" />
    </svg>
  </a>
);
